import { useState } from "react";
import { Box, Button } from "@mui/material";

const AlphabetSortWidget = ({ onSelectLetter }) => {
  const [selectedLetter, setSelectedLetter] = useState(null);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const handleLetterClick = (letter) => {
    const newSelectedLetter = selectedLetter === letter ? null : letter;
    setSelectedLetter(newSelectedLetter);

    if (onSelectLetter) {
      onSelectLetter(newSelectedLetter); // Call the parent function with null to indicate clearing
    }
  };

  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "flex-start", md: "center" },
          overflowX: "auto",
          whiteSpace: "nowrap",
          padding: "8px 0",
          gap: { xs: 0.5, md: 0.75 },
          "&::-webkit-scrollbar": { display: "none" }, // optionally hide scrollbar
        }}
      >
        {alphabet.map((letter) => (
          <Button
            key={letter}
            variant={selectedLetter === letter ? "contained" : "outlined"}
            onClick={() => handleLetterClick(letter)}
            sx={{
              minWidth: 32,
              width: 32,
              height: 32,
              p: 0,
              fontSize: "0.85rem",
              borderRadius: "50%",
              flex: "0 0 auto", // Prevents flex items from shrinking
            }}
          >
            {letter}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default AlphabetSortWidget;
